<template>
  <b-card class="translations-graph">
    <span
      class="translations-graph--title"
      :class="{ dark: isDarkMode }"
    >
      No of Translations
    </span>
    <span
      class="translations-graph--count"
      :class="{ dark: isDarkMode }"
    >
      {{ totalCount }}
    </span>
    <p
      v-if="!series.length && !isLoading"
      class="no-data-text"
    >
      No Data Found
    </p>
    <div
      class="d-flex align-items-center justify-content-center"
      style="height: calc(100% - 100px)"
    >
      <div id="noOfTranslationChart"></div>
    </div>
  </b-card>
</template>

<script>
import ApexCharts from "apexcharts";
import formatter from "@/mixins/formatter";

export default {
  name: "TranslationGraph",
  mixins: [formatter],
  props: {
    translationData: Array,
    isDarkMode: Boolean,
    isLoading: Boolean,
  },
  data() {
    return {
      noOfTranslationChart: null,
      series: [],
      options: {
        series: [],
        chart: {
          width: "100%",
          height: "100%",
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
            donut: {
              labels: {
                show: true,
                width: 300,
                color: "white",
              },
              size: "50%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: [
          "#ff6384",
          "#ff9f40",
          "#ffcd56",
          "#4bc0c0",
          "#36a2eb",
          "#a4a7a9",
        ],
        stroke: {
          width: 1,
        },
        legend: {
          enabled: false,
          markers: {
            radius: 0, // Set the radius to 0 to make legend boxes rectangular
          },
          fontSize: "14px",
          labels: {
            colors: "#989898",
          },
        },
      },
      totalCount: 0,
    };
  },
  watch: {
    translationData: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getFormattedData();
          this.updateChart();
          this.getTotalCount();
        }
      },
      deep: true,
    },
    isDarkMode(darkMode) {
      this.options = {
        ...this.options,
        theme: {
          mode: darkMode ? "dark" : "light"
        },
      };
      this.updateChart();
    }
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  methods: {
    getFormattedData() {
      const labels = [];
      const seriesData = [];

      if (this.translationData && this.translationData.length > 0) {
        this.translationData.map((value) => {
          seriesData.push(value.count);
          labels.push(value.language);
        });
      }

      this.series = [...seriesData];
      this.options = {
        ...this.options,
        theme: {
          mode: this.isDarkMode ? "dark" : "light",
        },
        series: seriesData,
        labels: [...labels],
      };
    },
    getTotalCount() {
      if (this.translationData && this.translationData.length > 0) {
        this.totalCount = 0;
        this.translationData.map((value) => (this.totalCount += value.count));
        this.totalCount = this.formatNumber(this.totalCount);
      }
    },
    renderChart() {
      this.noOfTranslationChart = new ApexCharts(
        document.querySelector("#noOfTranslationChart"),
        {
          ...this.options,
          series: [],
          labels: [],
        }
      );
      this.noOfTranslationChart.render();
    },
    updateChart() {
      this.noOfTranslationChart.updateOptions(this.options);
    }
  },
  beforeDestroy() {
    if (this.noOfTranslationChart) {
      this.noOfTranslationChart.destroy();
    }
  },
};
</script>

<style lang="scss">
.translations-graph {
  &.card {
    height: 386px;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    display: block;
    font-weight: 600;
    color: #333843;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  &--count {
    text-align: left;
    font-size: 2rem;
    color: #0b1354;
    font-weight: 500;
    padding-bottom: 16px;
  }
  &--count.dark {
    color: #b2b9bf !important;
  }
  & .apx-legend-position-right {
    overflow-y: inherit !important;
  }
  #noOfTranslationChart {
    width: 100%;
    height: calc(100% - 50px);
  }
  & .no-data-text {
    text-align: center;
    margin-top: 90px;
  }
}
</style>
